import React from 'react';
import Banner from './Banner/Banner';
import ContactsUs from './Contact/ContactsUs';
import Dentalcare from './Dentalcare/Dentalcare';
import Infocards from './Infocards/Infocards';
import Makeappointment from './Makeappoinment/Makeappointment';
import Service from './Service/Service';
import Testiminial from './Testemonial/Testiminial';

const Home = () => {
    return (
        <div className='mx-4'>
            <Banner></Banner>
            <Infocards></Infocards>
            <Service></Service>
            <Dentalcare></Dentalcare>
            <Makeappointment></Makeappointment>
            <Testiminial></Testiminial>
            <ContactsUs></ContactsUs>
        </div>
    );
};

export default Home;